module.exports = __webpack_public_path__ + "img/pending.0a8614b5.png";